/**
 * Native-aware OAuth configuration.
 *
 * In Capacitor native builds the WebView origin may be a local scheme
 * (capacitor://localhost) that the OAuth broker rejects. This helper
 * resolves the correct hosted origin so OAuth always uses an allowed
 * redirect_uri and broker URL.
 */

import { Capacitor } from '@capacitor/core';

/** The canonical hosted origin for this Lovable project. */
const HOSTED_ORIGIN =
  'https://c6121c69-0ed2-40cf-b8e2-39513bcea01e.lovableproject.com';

export interface OAuthConfig {
  /** True when running inside a Capacitor native shell. */
  isNative: boolean;
  /** The redirect_uri to pass to the OAuth flow. */
  redirectUri: string;
}

export const getOAuthConfig = (): OAuthConfig => {
  let isNative = false;
  try {
    isNative = Capacitor.isNativePlatform();
  } catch {
    // Capacitor not available → web
  }

  return {
    isNative,
    redirectUri: isNative ? HOSTED_ORIGIN : window.location.origin,
  };
};
